/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { getId } from '@fluentui/react/lib/Utilities';
import { getScopedTheme } from 'src/core/themes/luisStylist';

const theme = getScopedTheme('EntityDropdown');

/**
 * A function that generates an empty list item.
 */
export const getNotFoundItem = ({
    text,
    onClick,
    secondaryText
}: Pick<IContextualMenuItem, 'text' | 'onClick' | 'secondaryText'>): IContextualMenuItem => ({
    key: getId('newEntity'),
    text,
    secondaryText,
    onClick,
    disabled: !onClick,
    itemProps: {
        styles: {
            secondaryText: {
                paddingLeft: 0,
                flexGrow: 1,
                textAlign: theme.secondaryTextAlign,
                fontStyle: 'italic'
            },
            label: { flexGrow: 0 }
        }
    }
});
